import {Component, Input, OnInit} from '@angular/core';
import {AuthService} from "../../../Services/AuthService/auth.service";
import {Router} from "@angular/router";
import {BsModalService} from "ngx-bootstrap/modal";
import {UserStoreService} from "../../../Services/Admin/user-store.service";
import {AlertService} from "ngx-alerts";
import {PaymentService} from "../../../Services/Payment/payment.service";
import SoftwareListino from "../../../Models/SoftwareListino";

@Component({
  selector: 'app-modifica-elemento',
  templateUrl: './modifica-elemento.component.html',
  styleUrls: ['./modifica-elemento.component.scss']
})
export class ModificaElementoComponent implements OnInit {

  @Input() ListinoModifica;
  @Input() Categorie;


  url: any;
  CodiceListino:string="";
  ErroreCodiceListino:boolean = false;
  ErroreCodiceListinoSpazi: boolean = false;
  NomeProdotto:string="";
  ErroreNomeProdotto:boolean = false;
  CostoProdotto:number;
  ErroreCostoProdottoNull:boolean = false;
  ErroreCostoProdottoZero:boolean = false;
  ErroreCostoProdottoLettere:boolean = false;
  DescrizioneProdotto:string = "";
  ErroreDescrizioneProdotto:boolean = false;
  ErroreDescrizioneProdottoLength:boolean = false;
  ErroreRisoluzioneImmagine:boolean= false;
  ErroreFormatoImmagine: boolean = false;
  tastiPremuti:number;


  constructor(private auth: AuthService, private router: Router, public modalService: BsModalService, private userStore: UserStoreService, private alert: AlertService, public payment: PaymentService) { }

  ngOnInit(): void {
    this.tastiPremuti = 0;
    this.NomeProdotto = this.ListinoModifica.Descrizione;
    this.CodiceListino = this.ListinoModifica.CodiceArticolo;
    this.DescrizioneProdotto = this.ListinoModifica.Testo;
    this.CostoProdotto = this.ListinoModifica.Costo;
  }
  onSelectFile(event) { // called each time file input changes
    let img = new Image()
    try {
      img.src = window.URL.createObjectURL(event.target.files[0]);
      img.onload = () => {
        if((img.width/img.height) === 1) {
          if (img.width >= 200 && img.height >= 200){
            this.ListinoModifica.Img = event.target.files[0];
            this.ErroreRisoluzioneImmagine = false;
            this.ErroreFormatoImmagine = false;
          }else{
            this.ErroreRisoluzioneImmagine = true;
            this.ErroreFormatoImmagine = false;
            let resetForm = <HTMLFormElement>document.getElementById('uploadImageForm');
            resetForm.reset();
            this.ListinoModifica.Img =null;
          }
          // upload logic here
        } else {
          this.ErroreRisoluzioneImmagine = false;
          this.ErroreFormatoImmagine = true;
          let resetForm = <HTMLFormElement>document.getElementById('uploadImageForm');
          resetForm.reset();
          this.ListinoModifica.Img =null;
        }
      }
    } catch (e) {
      
    }
  }
  InputCodiceListino(){
    this.tastiPremuti++;
    if (this.CodiceListino.length === 0){
      this.ErroreCodiceListino = true;
      this.ErroreCodiceListinoSpazi = false;
    }else if(this.CodiceListino.includes(' ')){
      this.ErroreCodiceListinoSpazi = true;
      this.ErroreCodiceListino = false;
    } else {
      this.ListinoModifica.CodiceArticolo = this.CodiceListino;
      this.ErroreCodiceListinoSpazi = false;
      this.ErroreCodiceListino = false;
    }
  }
  InputNomeProdotto(){
    this.tastiPremuti++;
    if(this.NomeProdotto.length === 0){
      this.ErroreNomeProdotto = true;
    }else{
      this.ListinoModifica.Descrizione= this.NomeProdotto;
      this.ErroreNomeProdotto = false
    }
  }
  InputCostoProdotto(){
    let CostoProdottoTemp = String(this.CostoProdotto).replace(/[e\+\-]/gi, "");
    this.CostoProdotto = Number(CostoProdottoTemp);
    let roundedString = this.CostoProdotto.toFixed(2); //Arrotondamento
    this.CostoProdotto = Number(roundedString);
    if(isNaN(this.CostoProdotto)){
      this.ErroreCostoProdottoNull = true;
      this.ErroreCostoProdottoZero = false;
      this.ErroreCostoProdottoLettere = false;

    }else if(this.CostoProdotto === 0){
      this.ErroreCostoProdottoNull = false;
      this.ErroreCostoProdottoZero = true;
      this.ErroreCostoProdottoLettere = false;

    }else{
      this.ListinoModifica.Costo = this.CostoProdotto;
      this.ErroreCostoProdottoNull = false;
      this.ErroreCostoProdottoZero = false;
      this.ErroreCostoProdottoLettere = false;
    }

  }
  InputDescrizioneProdotto(){
    this.tastiPremuti++;
    if(this.DescrizioneProdotto.length == 0){
      this.ErroreDescrizioneProdotto = true;
    } else if(this.DescrizioneProdotto.length > 5000){
      this.ErroreDescrizioneProdottoLength= true;
      this.ErroreDescrizioneProdotto = false;
    }else{
      this.ListinoModifica.Testo = this.DescrizioneProdotto;
      this.ErroreDescrizioneProdottoLength= false;
      this.ErroreDescrizioneProdotto = false;
    }
  }
  public async Upload() {

    //CHECK...SE NON HO INSERITO TUTTI I CAMPI, ALERT.

    const id = await this.auth.GetIdByUsername();

    const result: boolean = await this.userStore.UploadListino(this.ListinoModifica, id);
    if (result) {
      this.modalService.hide();
      this.alert.success("Elemento aggiunto con successo");

      const ListinoAdd = Object.assign({}, this.ListinoModifica);
      this.Categorie.find(cat => cat.ID === ListinoAdd.IdCat).Elementi.push(ListinoAdd);

      this.ListinoModifica = new SoftwareListino();

    } else {
      this.alert.danger("Impossibile aggiungere l'elemento");
    }
  }
  async checkFormValidity(){

      let errori = 0;
      if (this.CodiceListino === ''){
        this.ErroreCodiceListino = true;
        errori++;
      }
      if(this.NomeProdotto  === ''){
        this.ErroreNomeProdotto = true;
        errori++;
      }
      if(this.CostoProdotto === 0){
        this.ErroreCostoProdottoZero = true;
        errori++;
      }
      if(this.DescrizioneProdotto === ''){
        this.ErroreDescrizioneProdotto = true;
        errori++;
      }
      if(this.ErroreCodiceListino || this.ErroreNomeProdotto || this.ErroreCostoProdottoNull || this.ErroreCostoProdottoLettere || this.ErroreCostoProdottoZero
        || this.ErroreDescrizioneProdotto || this.ErroreDescrizioneProdottoLength){
        this.alert.danger('Campi mancanti');
      } else{
        await this.EditListino();
        this.modalService.hide();
      }
    }

  public async EditListino() {
    //CHECK...SE NON HO INSERITO TUTTI I CAMPI, ALERT.
    if (this.ListinoModifica.CodiceArticolo === '' || this.ListinoModifica.Descrizione === '' || this.ListinoModifica.Costo === 0) {
      this.alert.danger('I campi non sono correttamente inseriti');
      return false;
    }

    const id = await this.auth.GetIdByUsername();

    const result: boolean = await this.userStore.EditListino(this.ListinoModifica, id);

    if (result) {
      this.modalService.hide();
      this.alert.success("Elemento modificato con successo");

      this.ListinoModifica = new SoftwareListino();

    } else {
      this.alert.danger("Impossibile modificare l'elemento");
    }
  }


}
